import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/DefaultCashLimitRow.css';
import useExtendedState from '../../hooks/useExtendedState';
import { defaultCashLimitType } from '../../types';
import useSingleValidator from '../../hooks/useSingleValidator';
import { defaultCashLimitValidator } from '../../validators/clearingHouses';
import PrivilegedNumberField from '../fields/privileged/PrivilegedNumberField';
import Privileges from '../../utils/Privileges';
import useEffectOnUpdate from '../../hooks/useEffectOnUpdate';

DefaultCashLimitRow.propTypes = {
    minCashLimit: PropTypes.number,
    maxCashLimit: PropTypes.number,
    defaultCashLimit: defaultCashLimitType.isRequired,
    onCashLimitChange: PropTypes.func.isRequired,
    canBeEdited: PropTypes.bool.isRequired,
    doReset: PropTypes.bool.isRequired,
    doResetComponentsAfterModification: PropTypes.bool.isRequired,
};

DefaultCashLimitRow.defaultProps = {
    minCashLimit: null,
    maxCashLimit: null,
};

function DefaultCashLimitRow(props) {
    const {
        minCashLimit,
        maxCashLimit,
        defaultCashLimit,
        onCashLimitChange,
        canBeEdited,
        doReset,
        doResetComponentsAfterModification,
    } = props;
    const { t } = useTranslation();
    const cashLimitState = useExtendedState(defaultCashLimit.cashLimit);
    const { validator, reset: resetCashLimitValidator } = useSingleValidator(true, useMemo(() => defaultCashLimitValidator(t, minCashLimit, maxCashLimit), [t, minCashLimit, maxCashLimit]));
    const onNewCashLimitValidated = (newCashLimit, isValid) => {
        onCashLimitChange(defaultCashLimit.currencyCode, newCashLimit, isValid);
    };
    useEffectOnUpdate(() => {
        if (doReset) {
            cashLimitState.reset();
            resetCashLimitValidator();
        }
    }, [doReset]);
    useEffectOnUpdate(() => {
        cashLimitState.changeInitialState(cashLimitState.value);
        cashLimitState.reset();
        resetCashLimitValidator();
    }, [doResetComponentsAfterModification]);
    return (
        <div className="detail-list-row default-cash-limit-row">
            <div className="default-cash-limit-cell default-cash-limit--currency-name">{defaultCashLimit.currencyName}</div>
            <div className="default-cash-limit-cell default-cash-limit--currency-code readonly">{defaultCashLimit.currencyCode}</div>
            <div className="default-cash-limit-cell default-cash-limit--cash-limit">
                <PrivilegedNumberField
                    sufficientPrivileges={canBeEdited ? [Privileges.CLEARING_HOUSE_EDIT] : []}
                    state={cashLimitState}
                    onValidated={onNewCashLimitValidated}
                    className="cash-limit"
                    validator={validator}
                    min={minCashLimit}
                    max={maxCashLimit}
                    decrementDisabled={cashLimitState.value <= minCashLimit}
                    incrementDisabled={cashLimitState.value >= maxCashLimit}
                    fractionDigits={2}
                />
            </div>
        </div>
    );
}

export default DefaultCashLimitRow;
